module.exports = __webpack_public_path__ + "static/media/picto-speech-bubble-blue.d9a14d5e.svg";